const initialState = {
  currentUser: {},
  hasFetchedUser: false,
  isAuthenticated: false,
  isAuthenticatedUnauth: false,
  redirectToLogin: false,
  authFailed: false,
  redirect: "",
  token: "",
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_USER":
      return {
        ...state,
        currentUser: action.userObj,
        isAuthenticated: action.isUnauth != true,
        isAuthenticatedUnauth: action.isUnauth == true,
        redirectToLogin: action.isUnauth == true,
        hasFetchedUser: true,
      };

    case "LOGOUT_USER":
      return {
        ...state,
        currentUser: {},
        isAuthenticated: false,
        isAuthenticatedUnauth: false,
        redirectToLogin: true,
        authFailed: action.authFailed,
        redirect: action.redirect,
        token: action.token,
        hasFetchedUser: true,
      };

    case "CLEAR_REDIRECT_USER":
      return {
        ...state,
        redirect: "",
        token: "",
      };
    case "UPDATE_PERMISSIONS":
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          roomInfo: action.roomInfo,
        },
      };
    case "UPDATE_USER":
      return {
        ...state,
        currentUser: action.userObj,
        hasFetchedUser: true,
      };
    case "RESET_AUTH":
      return { ...state, authFailed: false, hasFetchedUser: true };

    default:
      return state;
  }
}
